import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const originalFetch = window.fetch.bind(window);
let csrfMismatchHandled = false;

const showSessionExpiredBanner = () => {
    if (document.getElementById('session-expired-banner')) {
        return;
    }

    document.querySelectorAll('dialog[open]').forEach((dialog) => {
        if (typeof dialog.close === 'function') {
            dialog.close();
        }
    });

    if (window.toastr && typeof window.toastr.remove === 'function') {
        setTimeout(() => {
            window.toastr.remove();
        }, 50);
    }


    const banner = document.createElement('div');
    banner.id = 'session-expired-banner';
    const title = document.createElement('strong');
    title.textContent = 'Tu sesión expiró';
    title.style.fontSize = '1.125rem';
    title.style.marginRight = '12px';

    const message = document.createElement('span');
    message.textContent = 'Por favor volvé a iniciar para seguir trabajando.';

    banner.style.position = 'fixed';
    banner.style.top = '50%';
    banner.style.left = '50%';
    banner.style.transform = 'translate(-50%, -50%)';
    banner.style.zIndex = '2147483647';
    banner.style.padding = '16px';
    banner.style.background = '#b91c1c';
    banner.style.color = '#fff';
    banner.style.borderRadius = '8px';
    banner.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
    banner.style.display = 'flex';
    banner.style.justifyContent = 'space-between';
    banner.style.alignItems = 'center';
    banner.style.flexWrap = 'wrap';
    banner.style.gap = '12px';
    banner.style.maxWidth = '480px';
    banner.style.width = 'calc(100% - 32px)';

    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Recargar ahora';
    button.style.background = '#fff';
    button.style.color = '#b91c1c';
    button.style.border = 'none';
    button.style.borderRadius = '6px';
    button.style.padding = '8px 16px';
    button.style.cursor = 'pointer';
    button.style.fontWeight = '600';

    button.addEventListener('click', () => window.location.reload());

    const textContainer = document.createElement('div');
    textContainer.style.display = 'flex';
    textContainer.style.flexDirection = 'column';
    textContainer.style.gap = '8px';

    textContainer.appendChild(title);
    textContainer.appendChild(message);

    banner.appendChild(textContainer);
    banner.appendChild(button);
    document.body.appendChild(banner);

    console.log("CREO EL CARTEL")

};

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 419 && !csrfMismatchHandled) {
        csrfMismatchHandled = true;
        showSessionExpiredBanner();
    }

    return response;
};
